import React, { Component } from 'react';
import { Prompt } from 'react-router-dom';
import Axios from 'axios/index';
import config from '../../config/config';
import { connect } from 'react-redux';
import DateandTime from '../Transport/DateandTime';

class CensusManager extends Component {
	constructor(props) {
		super(props);
		this.state = {
			username: '',
			password: '',
			post: '',
			valid: false,
			msg: false,
			errorMsg: false,
			name: ''
		};
	}
	onHandleTextChange = e => {
		console.log(e.target.value);
		this.setState({
			[e.target.name]: e.target.value
		});
	};
	inputData = e => {
		console.log(e.target.value);
		this.setState({
			[e.target.name]: e.target.value
		});
	};

	onHandleSubmit = e => {
		e.preventDefault();
		const { username, password, name, post } = this.state;
		if (
			Object.is(username, '') ||
			Object.is(password, '') ||
			Object.is(name, '') ||
			Object.is(post, '')
		) {
			this.setState({
				valid: false,
				errorMsg: true
			});
		} else {
			this.setState({
				valid: true
			});
			let token = '';
			if (localStorage.jwtToken) {
				token += localStorage.getItem('jwtToken') + token;
			}
			var Headconfig = {
				headers: {
					'Access-Control-Allow-Origin': '*',
					Authorization: 'Bearer ' + token
				}
			};
			var bodyParameters = {
				userName: this.state.username,
				name: this.state.name,
				post: this.state.post,
				password: this.state.password,
				accountType: this.props.role,
				accountId: this.props.name
			};
			Axios.post(
				`${config.localhttp}/api/AdministrationManager`,
				bodyParameters,
				Headconfig
			)
				.then(response => {
					console.log(response);

					if (response.status == 200) {
						this.setState({
							username: '',
							password: '',
							name: '',
							post: '',
							msg: true
						});
					}
				})
				.catch(error => {
					if (error.response) {
						// The request was made and the server responded with a status code

						// that falls out of the range of 2xx
						console.log(error.response.data);
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received

						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
				});
		}
	};
	componentDidUpdate() {
		if (this.state.msg || this.state.errorMsg) {
			setTimeout(() => {
				this.setState({
					msg: false,
					errorMsg: false
				});
			}, 3000);
		}
	}
	Message = (msg, color, fontSize, flag) => {
		if (flag) {
			return (
				<p style={{ fontSize: fontSize }} class={`text-${color}`}>
					{msg}
				</p>
			);
		}
	};

	render() {
		return (
			<div className="container">
				<Prompt
					when={this.state.valid !== true}
					message="Leaving this form will lose your data"
				/>
				<section class="mb-4">
					<h2 class="h1-responsive font-weight-bold text-center my-4">
						Add Adminstration Manager
					</h2>

					<p class="text-center w-responsive mx-auto mb-5" />

					<div
						class="row"
						style={{
							justifyContent: 'center',
							textAlign: 'center'
						}}
					>
						<div
							class="col-md-9 mb-md-0 mb-5"
							style={{
								border: 'solid',
								borderColor: '#01ac8a',
								padding: 40,
								borderRadius: 15,
								width: 'auto'
							}}
						>
							{this.Message(
								'Manager Added Successfully!',
								'success',
								20,
								this.state.msg
							)}
							{this.Message(
								'Please fill the form properly!',
								'danger',
								20,
								this.state.errorMsg
							)}

							<form id="contact-form" name="contact-form">
								<div class="row">
									<div class="col-md-12">
										<div class="md-form mb-0">
											<DateandTime />
										</div>
									</div>
								</div>
								<br />
								<div class="row">
									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="name" class="">
												{/* <i
                                                    className="fas fa-user-shield animated fadeIn"
                                                    style={{ marginRight: 4 }}
                                                /> */}
												Admin Name
											</label>
											<input
												style={{ borderColor: '#01AC8A' }}
												type="text"
												readOnly={true}
												value={this.props.name}
												name="AdminName"
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>

									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="name" class="">
												{/* <i
                                                    className="fas fa-user-alt animated fadeIn"
                                                    style={{ marginRight: 4 }}
                                                /> */}
												Admin Type
											</label>
											<input
												style={{ borderColor: '#01AC8A' }}
												type="text"
												readOnly={true}
												value={this.props.role}
												name="AdminType"
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>

									<div class="col-md-6" style={{ marginTop: 20 }}>
										<div class="md-form mb-0">
											<label for="name" class="">
												<i
													className="fas fa-user-shield"
													style={{ marginRight: 4 }}
												/>
												Name
											</label>
											<input
												type="text"
												name="name"
												value={this.state.name}
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>

									<div class="col-md-6" style={{ marginTop: 20 }}>
										<div class="md-form mb-0">
											<label for="name" class="">
												<i
													className="fas fa-user-shield"
													style={{ marginRight: 4 }}
												/>
												Select Manager
											</label>
											<select
												onChange={this.inputData}
												class="custom-select"
												name="post"
											>
												<option>Choose Manager..</option>
												<option value="School Manager">School Manager</option>
												<option value="Census Manager">Census Manager</option>
												<option value="Registration Mangager">
													Registration Manager
												</option>
												<option value="Student Manager">Student Manager</option>
											</select>
										</div>
									</div>

									<div class="col-md-6" style={{ marginTop: 20 }}>
										<div class="md-form mb-0">
											<label for="name" class="">
												{/* <i className="fas fa-user-shield" style={{ marginRight: 4 }} /> */}
												Name
											</label>
											<input
												style={{ borderColor: '#01AC8A' }}
												type="text"
												placeholder="Enter Name"
												name="name"
												value={this.state.name}
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>

									<div class="col-md-6" style={{ marginTop: 20 }}>
										<div class="md-form mb-0">
											<label for="name" class="">
												{/* <i className="fas fa-user-shield" style={{ marginRight: 4 }} /> */}
												Select Manager
											</label>
											<select
												style={{ borderColor: '#01AC8A' }}
												onChange={this.inputData}
												class="custom-select"
												name="post"
											>
												<option>Choose Manager..</option>
												<option value="School Manager">School Manager</option>
												<option value="Census Manager">Census Manager</option>
												<option value="Registration Mangager">
													Registration Manager
												</option>
												<option value="Student Manager">Student Manager</option>
											</select>
										</div>
									</div>

									<div class="col-md-6" style={{ marginTop: 20 }}>
										<div class="md-form mb-0">
											<label for="name" class="">
												{/* <i className="fas fa-user" style={{ marginRight: 4 }} /> */}
												Username
											</label>
											<input
												style={{ borderColor: '#01AC8A' }}
												type="text"
												name="username"
												placeholder="Enter Username"
												value={this.state.username}
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>

									<div class="col-md-6" style={{ marginTop: 20 }}>
										<div class="md-form mb-0">
											<label for="name" class="">
												{/* <i className="fas fa-key" style={{ marginRight: 4 }} /> */}
												Password
											</label>
											<input
												style={{ borderColor: '#01AC8A' }}
												type="password"
												placeholder="Enter Password"
												name="password"
												value={this.state.password}
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>
								</div>
							</form>
							<br />
							<br />
							<div class="text-center text-md-center">
								<button onClick={this.onHandleSubmit} class="btns">
									Add
								</button>
							</div>
							<div class="status" />
						</div>
					</div>
				</section>
			</div>
		);
	}
}
function mapStateToProps(state) {
	return {
		auth: state.setUserReducer.auth,
		role: state.setUserReducer.users.role,
		name: state.setUserReducer.users.unique_name
	};
}
export default connect(
	mapStateToProps,
	null
)(CensusManager);
